/* eslint-disable no-param-reassign,no-continue */
import axios from 'axios';
import Core6DraggerCommon from './Core6DraggerCommon';
import Core6Config from '../core6/Core6Config';
import Core6Utilities from "../core6/Core6Utilities";

export default class Core6PositionedComponentDragger {
  static init() {
    this.initDraggablePositionedComponents();
    document.addEventListener('componentAdded', Core6PositionedComponentDragger.initDraggablePositionedComponents);
  }

  static initPositionedComponentDropareas() {
    //console.log('initPositionedComponentDropareas');
    //const previewFrame = Core6Utilities.getElement('#previewframe').contentWindow;
    //const dropzoneContainer = previewFrame.document.body.querySelector('.page');

    const componentDropareas = Core6Utilities.getElementAll('.component_droparea');
    for (let i = 0, len = componentDropareas.length; i < len; i += 1) {
      const componentDroparea = componentDropareas[i];
      componentDroparea.addEventListener('drop', Core6PositionedComponentDragger.dropPositionedComponentHandler);
      componentDroparea.addEventListener('dragover', Core6DraggerCommon.dragoverComponentHandler);
      componentDroparea.addEventListener('dragleave', Core6DraggerCommon.dragleaveComponentHandler);
    }
  }

  static initDraggablePositionedComponents() {
    //console.log('initDraggablePositionedComponents');

    Core6DraggerCommon.removeExcessDropareas();
    Core6DraggerCommon.removeDropareas('.component_droparea');
    // Positioned Components
    //const previewFrame = Core6Utilities.getElement('#previewframe').contentWindow;
    //const dropzoneContainer = previewFrame.document.body.querySelector('.page');

    const draggablePositionedComponents = Core6Utilities.getElementAll('.core6-mainrow-container:not(.isTemplate) .core6_component');
    for (let x = 0, len2 = draggablePositionedComponents.length; x < len2; x++) {
      const draggablePositionedComponent = draggablePositionedComponents[x];
      if (draggablePositionedComponent.getAttribute('draggable') == null) {
        draggablePositionedComponent.setAttribute('draggable', 'false');
        draggablePositionedComponent.addEventListener('dragstart', Core6PositionedComponentDragger.dragstartPositionedComponentHandler);
        draggablePositionedComponent.addEventListener('dragend', Core6PositionedComponentDragger.dragendPositionedComponentHandler);

        const handle = draggablePositionedComponent.querySelector('.drag-handle');
        //console.log('HANDLES');
        //console.log(handle);
        for (let i = 0; i < handle.length; i += 1) {
          handle[i].classList.add('avoid-clicks');
        }

        handle.addEventListener('mouseover', Core6PositionedComponentDragger.overHandle);
        handle.addEventListener('mouseout', Core6PositionedComponentDragger.leftHandle);
      }
    }
  }

  static overHandle(ev) {
    //console.log('OVER HANDLE');
    //const previewFrame = Core6Utilities.getElement('#previewframe').contentWindow;
    //const dropzoneContainer = previewFrame.document.body.querySelector('.page');

    const component = Core6Utilities.getElement(`.core6_component[data-component-id="${ev.target.getAttribute('data-component-id')}"]`);
    if (component !== null && component !== undefined) {
      component.setAttribute('draggable', 'true');
    } else {
      ev.target.style.cursor = 'not-allowed';
    }
  }

  static leftHandle(ev) {
    //const previewFrame = Core6Utilities.getElement('#previewframe').contentWindow;
    //const dropzoneContainer = previewFrame.document.body.querySelector('.page');
    const component = Core6Utilities.getElement(`.core6_component[data-component-id="${ev.target.getAttribute('data-component-id')}"]`);
    if (component !== null && component !== undefined) {
      component.setAttribute('draggable', 'false');
    } else {
      ev.target.style.cursor = 'not-allowed';
    }
  }

  static addPositionedComponentDropareas(componentIdBeingDragged) {
    //console.log('POSITIONED: function addPositionedComponentDropareas');
    //const previewFrame = Core6Utilities.getElement('#previewframe').contentWindow;
    //const dropzoneContainer = previewFrame.document.body.querySelector('.page');

    const dropzoneContainers = Core6Utilities.getElementAll('.row_content_container');
    if (dropzoneContainers.length === 0) {
      return;
    }

    // Loop through the containers
    for (let i = 0, len = dropzoneContainers.length; i < len; i++) {
      const dropzoneContainer = dropzoneContainers[i];
      const columns = dropzoneContainer.querySelectorAll('.row_content_container > div[class^="col-md-"]');

      // Loop through the columns
      for (let x = 0, len2 = columns.length; x < len2; x += 1) {
        const column = columns[x];

        const components = column.querySelectorAll('.core6_component');
        if (components.length === 0) {
          // TODO: ENABLE THE EXISTING PLACEHOLDER AS A DZ
          const noComponentsDz = column.querySelector('.core6_no_components');
          if ( noComponentsDz !== null && noComponentsDz !== undefined ) {
            noComponentsDz.classList.add('component_droparea');
            noComponentsDz.setAttribute('data-component-dz-new-index', 0);
          } else {
            console.log('no components dz not found!');
          }
        } else {
          for (let y = 0, len3 = components.length; y < len3; y += 1) {
            //console.log(`Dropzone added to: ${y}`);
            const component = components[y];

            if (component.getAttribute('data-component-id') === componentIdBeingDragged) {
              continue;
            }

            if (y === 0) {
              const componentDropAreaTemplateBefore = Core6DraggerCommon.htmlToElement(Core6PositionedComponentDragger.getComponentDropAreaTemplate());
              componentDropAreaTemplateBefore.setAttribute('data-component-dz-new-index', 0);
              // column.appendChild(componentDropAreaTemplateBefore);
              column.insertBefore(componentDropAreaTemplateBefore, component);
            }

            const nextComponentDZ = component.nextElementSibling;
            if (nextComponentDZ !== null) {
              const componentDropAreaTemplateAfter = Core6DraggerCommon.htmlToElement(Core6PositionedComponentDragger.getComponentDropAreaTemplate());
              componentDropAreaTemplateAfter.setAttribute('data-component-dz-new-index', y + 1);
              column.insertBefore(componentDropAreaTemplateAfter, nextComponentDZ);
            } else {
              const componentDropAreaTemplateAfter = Core6DraggerCommon.htmlToElement(Core6PositionedComponentDragger.getComponentDropAreaTemplate());
              componentDropAreaTemplateAfter.setAttribute('data-component-dz-new-index', y + 1);
              column.appendChild(componentDropAreaTemplateAfter);
            }
          }
        }
      }
    }
  }

  static dragstartPositionedComponentHandler(ev) {
    //console.log('dragstartPositionedComponentHandler');
    //console.log(ev);
    //console.log('POSITIONED: function dragstart_positioned_component_handler');
    ev.dataTransfer.setData('text/plain', ev.target.getAttribute('data-component-id'));

    // move, copy or link
    ev.dataTransfer.dropEffect = 'move';

    ev.target.style.opacity = 0.5;
    ev.target.style.zIndex = 9999;
    ev.target.classList.add('isDraggingMe');

    /* var img = new Image();
        img.src = 'img/example.jpg';
        ev.dataTransfer.setDragImage(img, 20, 20); */
    setTimeout(() => {
      Core6PositionedComponentDragger.addPositionedComponentDropareas(ev.target.getAttribute('data-component-id'));
      Core6PositionedComponentDragger.initPositionedComponentDropareas();
    }, 100);
  }

  static dragendPositionedComponentHandler(ev) {
    //console.log('POSITIONED: function dragend_positioned_component_handler');
    ev.target.style.opacity = 1;
    // Tidy up after dragging
    //const previewFrame = Core6Utilities.getElement('#previewframe').contentWindow;
    //const dropzoneContainer = previewFrame.document.body.querySelector('.page');
    const draggedComponents = Core6Utilities.getElementAll('.isDraggingMe');
    for (let i = 0, len = draggedComponents.length; i < len; i++) {
      const draggedComponent = draggedComponents[i];
      draggedComponent.classList.remove('isDraggingMe');
    }

    // Remove drop areas
    Core6PositionedComponentDragger.initDraggablePositionedComponents();
  }

  static dropPositionedComponentHandler(ev) {
    //console.log('POSITIONED: function drop_positioned_component_handler');
    ev.preventDefault();

    const data = ev.dataTransfer.getData('text');
    //console.log(data);

    // var node = core6_dragger_common.htmlToElement(core6_positioned_component_dragger.getComponentTemplate(data));
    //const previewFrame = Core6Utilities.getElement('#previewframe').contentWindow;
    //const dropzoneContainer = previewFrame.document.body.querySelector('.page');
    const node = Core6Utilities.getElement(`.core6_component[data-component-id="${data}"]`);
    //console.log(node);

    // var copy = $('.core6_component[data-component-id="' + data + '"]').clone(true, true);
    Core6Utilities.getJQueryElement(`.core6_component[data-component-id="${data}"]`).remove();

    node.classList.remove('avoid-clicks');
    node.removeAttribute('draggable');
    node.removeAttribute('style');

    ev.target.parentNode.insertBefore(node, ev.target);
    Core6PositionedComponentDragger.saveComponentOrdering();
    Core6PositionedComponentDragger.initPositionedComponentDropareas();
  }

  static saveComponentOrdering() {
    const jsonData = {};
    jsonData.updateList = [];
    //const previewFrame = Core6Utilities.getElement('#previewframe').contentWindow;
    //const dropzoneContainer = previewFrame.document.body.querySelector('.page');
    [].forEach.call(Core6Utilities.getElementAll('.row_content_container > div[class^="col-md-"]'), (column) => {
      /**
       *    GET COLUMN INDEX
       */
      const index = Array.prototype.indexOf.call(column.parentNode.children, column);

      /**
       *     OUTPUT COLUMN AND ROW
       */
      //console.log(`Row ${column.parentNode.dataset.rowId}, index ${index} contains...`);

      /**
       *    LOOP THROUGH CHILDREN OF COLUMN
       */
      let order = 0;
      [].forEach.call(column.children, (component) => {
        if ((` ${component.className} `).replace(/[\n\t]/g, ' ').indexOf('core6_component') > -1) {
          //console.log(`---- Component ID ${component.dataset.componentId} is in position ${order}`);
          jsonData.updateList.push({
            row: column.parentNode.dataset.rowId,
            columnIndex: index,
            component_id: component.dataset.componentId,
            component_order: order,
          });
          order += 1;
        }
      });
    });

    const formData = new FormData();
    formData.append('jsonData', JSON.stringify(jsonData));

    const config = Core6Config.getAjaxConfig();

    axios.post('/api/components/update/ordering', formData, config)
      .then((response) => {
        //console.log(`Received ${response}`);
        Core6DraggerCommon.removeDropareas('.component_droparea');
      })
      .catch((error) => {
        console.error(error);
      });
  }

  static getComponentDropAreaTemplate() {
    //console.log('NEW: function getComponentDropAreaTemplate');
    return "<div class='component_droparea core6_drop_component_here'></div>";
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6_dragger/Core6PositionedComponentDragger.js